export default __webpack_public_path__ + "static/media/recruitment.a93ddf62.svg";